'use strict';

/* eslint no-undef: "off" */
/**
 * XPark home footer
 */
define('xparkHomeFooter',['svgIcon'], function (svgIcon) {
  return {
    template: '\n      <footer class="xp-home-footer" v-html="footerHtml"></footer>\n    ',
    data: function data() {
      return {
        logo: window.commonDataJSON.logo,
        countries: window.commonDataJSON.xpark_webs || [],
        footerHtml: window.commonDataJSON.footer,
        navItems: [{ label: 'About Us', url: '/about-us' },
        // { label: 'After Sale', url: 'javascript:void(0);' },
        { label: 'Return Policy', url: '/return-policy' }, { label: 'Privacy Policy', url: '/privacy-policy' }, { label: 'Terms Of Use', url: '/terms-of-use' }, { label: 'FAQ', url: '/faq' }],
        socialItems: [{ name: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/share/18YWYtmRrF/' }, { name: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@xparknigeria?_r=1&_t=ZS-96XyYc0aeO4' }, { name: 'whatsapp', label: 'WhatsApp', url: 'https://wa.me/2347049658577' }, { name: 'x', label: 'X', url: 'javascript:void(0);' }, { name: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/xparknigeria?igsh=MWpveWo0aW1tNHR3cg==' }, { name: 'youtube', label: 'YouTube', url: 'javascript:void(0);' }]
      };
    },

    components: {
      svgIcon: svgIcon
    },
    computed: {
      currentCountry: function currentCountry() {
        return this.findSelectedCountry();
      }
    },
    methods: {
      findSelectedCountry: function findSelectedCountry() {
        return this.countries.filter(function (country) {
          return country.isCurrent;
        })[0] || this.countries[0] || null;
      }
    }
  };
});
